// extracted by mini-css-extract-plugin
module.exports = {"amplify-nosignup":"authWrapper_amplify-nosignup__1-PTl"};